import {request} from "./request";

export const verifyNameExistence = params => {
  return request.post({
    path: "/engine/verify/name/exist",
    params,
  });
};

export const verifyEmailExistence = params => {
  return request.post({
    path: "/engine/verify/email/exist",
    params,
  });
};

export const sendVerificationEmail = params => {
  return request.post({
    path: "/engine/verify/email/send",
    params,
  });
};

export const verifyEmailCode = params => {
  return request.post({
    path: "/engine/verify/email/code",
    params,
  });
};

export const verifyNickName = params => {
  return request.post({
    path: "/engine/verify/name/exist",
    params,
  });
};
